module.exports = __webpack_public_path__ + "img/zhu_xc11.0cfdebde.jpg";